export default __webpack_public_path__ + "static/media/next.f8660acc.svg";